import React from 'react';
import { Typography, TypographyProps } from '@mui/material';

export default function LimitedTypography({
  clamp,
  ...props
}: TypographyProps & { clamp: number }) {
  return (
    <Typography
      {...props}
      sx={{
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        wordBreak: 'break-all',
        WebkitLineClamp: clamp,
        ...props?.sx,
      }}
    ></Typography>
  );
}
